<template>
    <div class="container w-full pb-[100px]">
        <div
            class="promotion-header hidden cursor-pointer lg:mt-[33px] lg:flex lg:items-center"
        >
            <img
                :src="`${staticUrl}/assets/img/promotions/icon_back.svg`"
                alt="back"
                @click="$router.back()"
            />
            <span
                class="text-lg font-bold text-black"
                @click="$router.back()"
                >{{ $t('sidebar.promotion') }}</span
            >
        </div>
        <div
            class="promotion-categories mt-4 flex w-full items-center gap-x-4 border-b-[2px] border-solid border-[#E8EDF1] px-[5px]"
        >
            <div
                v-for="(category, index) in categories"
                :key="index"
                :class="[
                    'promotion-categories__item h-[30px] cursor-pointer',
                    {
                        'border-b-[2px] border-solid border-[#B01E46]':
                            category.key === activeCategory,
                    },
                ]"
                @click="changeCategory(category)"
            >
                <span
                    :class="[
                        'text-sm font-normal text-[#555555]',
                        { 'text-[#B01E46]': category.key === activeCategory },
                    ]"
                    >{{ $t(category.i18n_key) }}</span
                >
            </div>
        </div>

        <div class="mt-2">
            <div class="grid grid-cols-2 gap-4 lg:grid-cols-3 lg:gap-8">
                <div
                    v-for="(promotion, index) in promotions"
                    :key="index"
                    class="justify-center"
                >
                    <img
                        :src="`${staticUrl}/assets/img/promotions/${promotion.image}`"
                        class="w-full cursor-pointer object-cover pb-2 lg:h-[500px]"
                        alt="image"
                        @click="$router.push(promotion.link)"
                    />
                    <div
                        class="mb-2 text-sm font-bold hover:cursor-pointer hover:underline lg:text-base"
                        @click="$router.push(promotion.link)"
                    >
                        {{ $t(promotion.title) }}
                    </div>
                    <div class="line-clamp-4 text-sm lg:line-clamp-none">
                        {{ $t(promotion.content) }}
                    </div>
                    <div v-if="promotion.time" class="">
                        <span>{{ promotion.time }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { promotionList } from '@/constants/promotion.js'
const staticUrl = useRuntimeConfig().public.staticUrl
const categories = [
    {
        title: 'All',
        key: 'all',
        i18n_key: 'events.all',
    },
    {
        title: 'Promotion',
        key: 'promotion',
        i18n_key: 'events.promotions',
    },
    {
        title: 'Events',
        key: 'events',
        i18n_key: 'events.events',
    },
]
const promotions = ref([])

const activeCategory = ref('all')

const changeCategory = (category) => {
    activeCategory.value = category.key
    if (category.key === 'all') {
        promotions.value = promotionList
        return
    }
    promotions.value = promotionList.filter((e) => e.category === category.key)
}

onBeforeMount(() => {
    promotions.value = promotionList
})
</script>
